import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { extractDate } from "../../../Components/Functions/date.fun";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { FcStackOfPhotos } from "react-icons/fc";
import { FaLeaf } from "react-icons/fa6";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const getScheduleBadge = (schedule) => {
  if (schedule === "Watering") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>{" "}
      </p>
    );
  }
  if (schedule === "Watering + fertilizers 19:19:19 (1gm/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-orange text-white m-1">
          Fertilizers NPK(19-19-19) (1gm/ltr)
        </span>
      </p>
    );
  }
  if (schedule === "Watering + fertilizers 19:19:19 (1.5gm/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-orange text-white m-1">
          Fertilizers NPK(19-19-19) (1.5gm/ltr)
        </span>
      </p>
    );
  }
  if (schedule === "Watering + neem oil sprey (1ml/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-purple text-white m-1">
          Neem oil sprey (3000PPM) (1ml/ltr)
        </span>
      </p>
    );
  }
  if (schedule === "Watering + chelated ferrous (1gm/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-purple text-white m-1">
          Chelated ferrous (1ml/ltr)
        </span>
      </p>
    );
  } else {
    return schedule;
  }
};
const getBg = (date, scheduleDone) => {
  const today = new Date().toISOString().split("T")[0];
  const scheduledDate = new Date(date).toISOString().split("T")[0];

  if (scheduledDate > today) {
    return "";
  } else if (scheduledDate === today) {
    return "bg-primary-lt text-dark";
  } else {
    return scheduleDone ? "bg-green-lt text-dark" : "bg-red-lt text-dark";
  }
};

const ViewBatch = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();

  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/nurseryManagement/getNurseryManagementById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting batch details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        Toast("error", "Server Error!");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcStackOfPhotos className="fs-2  me-1" />
                  Nursery Management
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} View nursery details.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a
                    href={"/farm-nursery-management/"}
                    className="btn btn-primary"
                  >
                    {" "}
                    <FaLeaf className="fs-3 me-2" />
                    ALL BATCHES
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card table-responsive">
                <table className="table table-striped table-vcenter">
                  <thead>
                    <tr>
                      <th>Specs</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                      data && (
                        <tr>
                          <td>Project Name</td>
                          <td>{(data?.farmName || "N/A").toUpperCase()}</td>
                        </tr>
                      )}
                    {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                      data && (
                        <tr>
                          <td>Project Address</td>
                          <td>
                            {(data?.projectAddress || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                    {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                      data && (
                        <tr>
                          <td>Contact</td>
                          <td>
                            {(data?.clientPhoneNumber || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                    {data && (
                      <tr>
                        <td>Batch</td>
                        <td>
                          {(
                            extractDate(data?.batchName) || "N/A"
                          ).toUpperCase()}
                        </td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Crop</td>
                        <td>
                          {(
                            data?.agronomyWikiUpdate?.name || "N/A"
                          ).toUpperCase()}
                        </td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td>Plant Count</td>
                        <td>{data.numberOfplants || "N/A"}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {data?.cropPackFront && (
                  <div className="p-2 text-center">
                    <p className="text-center pt-3">Crop packet front image</p>
                    <hr className="m-0 p-0"></hr>
                    {data.cropPackFront && (
                      <LazyImageComponent
                        width="300px"
                        height="300px"
                        src={data?.cropPackFront}
                        alt="Crop packet front image"
                      />
                    )}
                  </div>
                )}
                <hr className="m-0 p-0"></hr>
                {data?.cropPackBack && (
                  <div className="p-2 text-center">
                    <p className="text-center pt-3">Crop packet back image</p>
                    <hr className="m-0 p-0"></hr>
                    {data.cropPackBack && (
                      <LazyImageComponent
                        width="300px"
                        height="300px"
                        src={data?.cropPackBack}
                        alt="Crop packet front image"
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <div className="table-responsive">
                  {data && (
                    <table className="table table-vcenter">
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th>schedule on</th>
                          <th>Schedule work</th>
                          <th>crop Image</th>
                          <th>Mark work done</th>
                          <th>Work done date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.schedule?.map((schedule, index) => {
                          return (
                            <tr
                              key={index}
                              className={getBg(
                                schedule?.date,
                                schedule?.scheduleDone
                              )}
                            >
                              <td
                                className={`${
                                  themeSet === "dark" ? "text-light" : ""
                                }`}
                              >
                                {++index}
                              </td>
                              <td
                                className={`${
                                  themeSet === "dark" ? "text-light" : ""
                                }`}
                              >
                                {(schedule?.date).toUpperCase()}
                              </td>
                              <td
                                className={`${
                                  themeSet === "dark" ? "text-light" : ""
                                }`}
                              >
                                {schedule.schedule
                                  ? getScheduleBadge(schedule.schedule)
                                  : "No task"}{" "}
                                {(schedule?.actions).toUpperCase()}
                              </td>
                              <td>
                                {schedule?.cropUploadPhoto ? (
                                  <LazyImageComponent
                                    width="25%"
                                    src={schedule?.cropUploadPhoto}
                                    alt={schedule?.cropUploadPhoto}
                                  />
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td
                                className={`${
                                  themeSet === "dark" ? "text-light" : ""
                                }`}
                              >
                                {(schedule?.scheduleDone
                                  ? "YES"
                                  : "NO"
                                ).toUpperCase()}
                              </td>
                              <td
                                className={`${
                                  themeSet === "dark" ? "text-light" : ""
                                }`}
                              >
                                {(
                                  schedule?.scheduleDoneDate || "N/A"
                                ).toUpperCase()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Edit batch"
                      href={`/farm-nursery-management/edit/${id}`}
                    />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewBatch;
